module.exports = __webpack_public_path__ + "static/media/Person10.4915ab6a.png";